import HomeHowItWorks from './HomeHowItWorks'
export default HomeHowItWorks